/**
 * Clases CSS compartidas para formularios.
 * Centraliza estilos para que un cambio de marca se aplique en un solo lugar.
 */

export const inputCls =
  'w-full px-3 py-2 text-sm border border-input-border rounded-lg bg-input-bg text-content focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary-200 transition-all placeholder:text-content-subtle'

export const inputCompactCls =
  'w-full px-2.5 py-1.5 text-xs border border-input-border rounded-md bg-input-bg text-content focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary-200 transition-all placeholder:text-content-subtle'

// Intermedio entre inputCls y inputCompactCls: tipografía sm pero padding vertical reducido.
// Útil en paneles con muchos campos donde text-xs se vuelve incómodo de editar.
export const inputSmallCls =
  'w-full px-3 py-1.5 text-sm border border-input-border rounded-lg bg-input-bg text-content focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary-200 transition-all placeholder:text-content-subtle'

export const labelCls = 'block text-sm font-medium text-content mb-1'

export const labelCompactCls = 'block text-xs font-medium text-content-muted mb-0.5'

// Label para vistas read-only (detail modals): patrón key-value, tono más tenue que el label de formulario.
export const displayLabelCls = 'block text-xs font-medium text-content-muted mb-1'

// 600 y no 500: con `text-red-500` el mensaje de error daba 3,76:1 sobre blanco,
// bajo el 4,5:1 que pide el texto, y no tenía variante oscura (2026-09-30).
export const errorCls = 'mt-1 text-xs text-danger-content-soft'

export const sectionTitleCls = 'text-xs font-semibold text-content-subtle uppercase tracking-wider mb-3'
